module.exports = __webpack_public_path__ + "img/big-3.dba1320f.png";